export const allFilterLabels = [
  { key: 'age', label: 'Age' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'company', label: 'Company' },
  { key: 'industry', label: 'Industry' },
  { key: 'title', label: 'Job Title or level' },
  { key: 'mName', label: 'Middle Name' },
  { key: 'birthMonth', label: 'Birth Month' },
  { key: 'birthYear', label: 'Birth Year' },
];
export const filterKeyToLabel: Record<string, string> = {
  fullName: 'Full Name',
  fName: 'First Name',
  mName: 'Middle Name/Initials',
  lName: 'Last Name',
  age: 'Age',
  company: 'Company',
  company_size_min: 'Company Size Min',
  company_size_max: 'Company Size Max',
  birthMonth: 'Birth Month',
  birthYear: 'Birth Year',
  deathMonth: 'Death Month',
  deathYear: 'Death Year',
  title: 'Job Title or level',
  industry: 'Industry',
  country: 'Country',
  location: 'Location (City, State)',
  number: 'Number',
  street: 'Street',
  city: 'City',
  state: 'State',
  level: 'Level',
  address: 'Address',
  isDeceased: 'Is Deceased',
};

export const FILTER_KEYS = {
  age: 'age',
  location: 'location',
  city: 'city',
  state: 'state',
  country: 'country',
  address: 'address',
  company: 'company',
  company_size_min: 'company_size_min',
  company_size_max: 'company_size_max',
  fullName: 'fullName',
  fName: 'fName',
  mName: 'mName',
  lName: 'lName',
  title: 'title',
  industry: 'industry',
  deathYear: 'deathYear',
  deathMonth: 'deathMonth',
  birthYear: 'birthYear',
  birthMonth: 'birthMonth',
  advanced_search: 'advancedSearch',
  source: 'source',
};

export const MESSAGES_SECTION_TYPES = {
  plain: 'plain' as const,
  filters: 'filters' as const,
  suggestions: 'suggestions' as const,
  results: 'results' as const,
};

export const ROLES = {
  user: 'user' as const,
  assistant: 'assistant' as const,
};

export const CONFIRM_CHIP_VARIANTS = {
  confirm: 'confirm' as const,
  viewResults: 'viewResults' as const,
};
